import { createSlice } from "@reduxjs/toolkit";
import { viewTestimonials } from "../actions/testimonialsAction";

const testimonialSlice = createSlice({
  name: "testimonials",
  initialState: {
    testimonials: [],
    loading: false,
    error: null,
    success: false,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(viewTestimonials.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(viewTestimonials.fulfilled, (state, action) => {
        state.loading = false;
        state.testimonials = action.payload;
      })
      .addCase(viewTestimonials.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default testimonialSlice.reducer;
